
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import Popup from "../popup/popup.vue";
import store from "../../core/store";
import { Settings } from "../../core/services/configService";
import { CrudService } from "../../core/services/crudService";
import InputPassword from "../../components/form/inputPassword.vue";
import InputText from "../../components/form/inputText.vue";
import SubmitButton from "../../components/submitButton/submitButton.vue";
import { Format } from "../../core/helpers/formatHelper";
import { CustomerHelper } from "../../crm/helpers/customerHelper";
import { CustomerStatus } from "@shared/crm/constants";

@Component({
  components: { Popup, InputPassword, InputText, SubmitButton },
})
export default class LoginForm extends Vue {
  @Prop({ default: false }) validateOnly!: boolean;
  private CustomerStatus = CustomerStatus;

  email: string = "";
  password: string = "";
  resetPassEmail: string = "";

  error: string = "";
  loginButtonTxt: string = "";

  resetPasswordMode: boolean = false;
  resetSent: boolean = false;
  registerOk: boolean = false;
  private resetCustomerStatus: CustomerStatus|null = null;

  mounted() {
    this.error = "";
    this.loginButtonTxt = this.$t("Login").toString();
  }

  submit(e: any) {
    e.preventDefault();

    this.error = "";
    this.registerOk = false;

    if (this.resetSent) {
      this.closeLogin();
      return;
    }

    if (this.resetPasswordMode) {
      this.resetPassword();
      return;
    }

    this.login();
  }

  @Emit("onLogin")
  async login() {
    if (this.email.indexOf("@") === -1) {
      this.error =
        this.$t(
          "For security reasons, the user name to log into your account will be your email"
        ).toString() +
        ". " +
        this.$t(
          "You wont be able to use your phone number any more"
        ).toString() +
        ". " +
        this.$t("Please contact the center if you need assistance").toString();
      return;
    }

    let url = `${Settings.HostName}/api/publiccustomers/cauth`;
    let data = await new CrudService().httpPost(url, {
      email: this.email,
      password: this.password,
      externalToken: this.$route.query.token,
    });

    if (data == null) {
      console.error("Crash on login");
      return;
    }

    if (data.ok === false) {
      if (
        data.errorMsg !== "" &&
        data.errorMsg !== null &&
        data.errorMsg !== undefined
      ) {
        this.error = data.errorMsg;
        if (data.redirect !== undefined && data.redirect === true) {
          this.resetPassModeOn();
        }
        return;
      }
      this.error = this.$t("Invalid Email or Password").toString();
      return;
    }

    if (this.validateOnly !== true) {
      this.closeLogin();
      CustomerHelper.saveLogedCustomer(
        data.model.token,
        data.model.expiry,
        data.model.id,
        data.model.logo,
        data.model.name,
        data.model.surname
      );
      store.state.loggedIn = true;
      if (!Format.IsNull(store.state.loginRedirect)) {
        location.href = store.state.loginRedirect;
      }
    }

    return { ok: data.ok, id: data.model?.id };
  }

  async resetPassword() {
    this.loginButtonTxt = this.$t("Close").toString();
    
    let url = `${Settings.HostName}/api/publiccustomers/reset-password-request-cz`;
    let data = await new CrudService().httpPost(url, {
      email: this.resetPassEmail,
    });
    this.resetSent = true;
    
    if (data == null || data.ok == false) {
      console.error("Crash on reset-password-request-cz");
      return;
    }
    this.resetCustomerStatus = data.customerStatus;
  }

  @Emit("close")
  closeLogin() {}

  resetPassModeOn(e: any = null) {
    if (e !== null) {
      e.preventDefault();
    }

    this.loginButtonTxt = this.$t("Send").toString();
    this.resetPasswordMode = true;
  }
}
